const state = {
  list: {
    data: []
  },
  current: null,
  loading: false,
  error: false
}

const getters = {}

const actions = {
  async getOne({ commit, dispatch }, params) {
    commit('REQUEST')

    const { data } = await dispatch(
      `api`,
      { entity: `yardChecklist`, action: `getOne`, params },
      { root: true }
    )

    if (data) {
      commit('SUCCESS-GET-ONE', data)
    } else {
      commit('ERROR')
    }
  },
  async getAll({ commit, dispatch }, query) {
    commit('REQUEST')

    const { data } = await dispatch(
      `api`,
      { entity: `yardChecklist`, action: `getAll`, query },
      { root: true }
    )

    if (data) {
      commit('SUCCESS-GET-ONE', data)
    } else {
      commit('ERROR')
    }
  }
}

const mutations = {
  ['REQUEST'](state) {
    state.loading = true
  },
  ['ERROR']() {
    state.error = true
    state.loading = false
  },
  ['SUCCESS_GET_ALL'](payload) {
    state.error = false
    state.loading = false
    state.data.list = payload
  },
  ['SUCCESS_GET_ONE'](payload) {
    state.error = false
    state.loading = false
    state.data.current = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
